import { render, staticRenderFns } from "./shortcuts.vue?vue&type=template&id=6d40dba1&scoped=true"
import script from "./shortcuts.vue?vue&type=script&lang=js"
export * from "./shortcuts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d40dba1",
  null
  
)

export default component.exports